import React from 'react';
import { Tabs, Alert } from 'antd';
import SdgTabGroup from 'components/tabs/SdgTabGroup';
import IloTabGroup from 'components/tabs/IloTabGroup';
import WdiTabGroup from 'components/tabs/WdiTabGroup';
import UnescoTabGroup from 'components/tabs/UnescoTabGroup';
import FaoTabGroup from 'components/tabs/FaoTabGroup';
import WhoTabGroup from 'components/tabs/WhoTabGroup';
import ImfTabGroup from 'components/tabs/ImfTabGroup';
import IrenaTabGroup from 'components/tabs/IrenaTabGroup';

const { TabPane } = Tabs;

const AutoFetch = () => {
  const isHidden = true;

  return (
    <div style={{ padding: 0 }}>
      <h1>Auto Fetch Page</h1>
      <Alert
        message="This page is dedicated to fetching data from external APIs. Use the tabs to switch between different API sources (e.g., SDG API) and configure or trigger requests here. It is still a prototype, so some features may not be fully functional yet."
        type="warning"
        showIcon
        style={{ marginBottom: 16 }}
      />

      <Tabs defaultActiveKey="sdg">
        <TabPane tab="SDG" key="sdg">
          <SdgTabGroup />
        </TabPane>
        <TabPane tab="ILO" key="ilo">
          <IloTabGroup />
        </TabPane>
        <TabPane tab="WDI" key="wdi">
          <WdiTabGroup />
        </TabPane>
        <TabPane tab="UNESCO" key="unesco">
          <UnescoTabGroup />
        </TabPane>
        <TabPane tab="FAO" key="fao">
          <FaoTabGroup />
        </TabPane>
        <TabPane tab="WHO" key="who">
          <WhoTabGroup />
        </TabPane>
        <TabPane tab="IMF" key="imf">
          <ImfTabGroup />
        </TabPane>
        {!isHidden && (
          <TabPane tab="IRENA" key="irena">
            <IrenaTabGroup />
          </TabPane>
        )}
      </Tabs>
    </div>
  );
};

export default AutoFetch;
